"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai-assist.suggestions.header': 'Suggerimenti IA',
    'ai-assist.suggestions.close': 'Chiudi',
    'ai-assist.suggestions.intro': 'Seleziona un suggerimento per applicarlo al tuo prompt:',
};
